import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  const byId = (id) => document.getElementById(id);

  const subscriptionIntentionEl = byId('subscription-intention-id');
  if (!subscriptionIntentionEl) {
    return;
  }

  consumer.subscriptions.create(
    {
      channel: 'SubscriptionIntentionChannel',
      subscription_intention_id: subscriptionIntentionEl.dataset.id,
    },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            setTimeout(() => {
              window.location.href = data.next_step_path;
            }, 5000);
          } else if (data.status === 'failure') {
            setTimeout(() => {
              byId('subscriptionStep1')?.classList.add('d-none');
              byId('subscriptionStep1Failure')?.classList.remove('d-none');
            }, 5000);
          } else {
            setTimeout(() => {
              byId('subscriptionStep1')?.classList.add('d-none');
              byId('subscriptionStep1Error')?.classList.remove('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            byId('subscriptionStep1')?.classList.add('d-none');
            byId('subscriptionStep1Error')?.classList.remove('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          byId('subscriptionStep1')?.classList.add('d-none');
          byId('subscriptionStep1Error')?.classList.remove('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
